import React, { useRef, useEffect } from "react"
import { clamp, relativeProgress as rp } from "../../utils/math"
import { af as AF } from "@gladeye/af"
import Spacing from "./Spacing"

const ColorChangeBG = ({ children, from, to }) => {
    const el = useRef()

    useEffect(() => {
        const af = AF()
        let prog

        function read() {
            const { top, height } = el.current.getBoundingClientRect()
            const wh = window.innerHeight

            const transTime = Math.max(height - wh)

            prog = rp(top * -1, 0, transTime)
        }

        function write() {
            const r = from.r + (to.r - from.r) * prog
            const g = from.g + (to.g - from.g) * prog
            const b = from.b + (to.b - from.b) * prog

            el.current.style.backgroundColor = `rgb( ${r}, ${g}, ${b})`
        }

        af.addRead(read)
        af.addWrite(write)

        return () => {
            af.removeRead(read)
            af.removeWrite(write)
        }
    }, [])

    return (
        <div
            style={{
                width: "100%",
                clear: "both",
            }}
            ref={el}
        >
            {children}

            <Spacing space="0"></Spacing>
        </div>
    )
}

export default ColorChangeBG
